module.exports = __webpack_public_path__ + "img/dp-gr-sy2.3c075df8.png";